import { withI18n } from 'react-i18next';
import ArSummaryCard from './ArSummaryCard';

export const pureComponent = ArSummaryCard;
export default withI18n()(ArSummaryCard);
